const MEMBERSHIP_OFFER_ENDPOINT = 'getsubscriptionoffer';
const MEMBERSHIP_USER_TYPE_ENDPOINT = 'getusertype';
const MEMBERSHIP_CUSTOMER_ENDPOINT = 'getcustomermembership';
const IS_USER_REGISTERED_ENDPOINT = 'isuserregistered';
const MEMBERSHIP_ENABLE_AUTO_RENEWAL = 'enableautorenewal';
const MEMBERSHIP_DISABLE_AUTO_RENEWAL = 'disableautorenewal';

module.exports = {
    MEMBERSHIP_OFFER_ENDPOINT,
    MEMBERSHIP_USER_TYPE_ENDPOINT,
    MEMBERSHIP_CUSTOMER_ENDPOINT,
    IS_USER_REGISTERED_ENDPOINT,
    MEMBERSHIP_ENABLE_AUTO_RENEWAL,
    MEMBERSHIP_DISABLE_AUTO_RENEWAL,
};
